import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// 📣 The reseller bar at the bottom of the screen. Change the words here any time.
const BAR_TITLE = "🎓 Premium Resellers Academy: Coming Soon";
const BAR_SUB = "Be notified when it launches →";
const BAR_LINK = "https://bundle.manayadatalink.com";

const CLOSED_KEY = "mad_bundle_bar_closed_at";
const HIDE_DAYS = 3;
const HIDE_ON = ["/buy", "/purchase", "/payment-success"];
const BAR_HEIGHT = "52px";

function wasClosedRecently(): boolean {
  try {
    const t = Number(localStorage.getItem(CLOSED_KEY) || 0);
    return t > 0 && Date.now() - t < HIDE_DAYS * 86400000;
  } catch {
    return false;
  }
}

export default function BundleBar() {
  const { pathname } = useLocation();
  const [closed, setClosed] = useState<boolean>(wasClosedRecently);
  const hidden = closed || HIDE_ON.some((p) => pathname === p || pathname.startsWith(p + "/"));

  useEffect(() => {
    const root = document.documentElement;
    if (hidden) {
      root.style.removeProperty("--bar-h");
      document.body.style.paddingBottom = "";
    } else {
      root.style.setProperty("--bar-h", BAR_HEIGHT);
      document.body.style.paddingBottom = BAR_HEIGHT;
    }
    return () => {
      root.style.removeProperty("--bar-h");
      document.body.style.paddingBottom = "";
    };
  }, [hidden]);

  if (hidden) return null;

  const onTap = () => {
    fetch("https://api.manayadatalink.com/bundle-events", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({ type: "choice", data: { choice: "bar_click" }, page: pathname }),
    }).catch(() => {});
  };

  const onClose = () => {
    try {
      localStorage.setItem(CLOSED_KEY, String(Date.now()));
    } catch {
      /* private mode: bar will come back next visit */
    }
    setClosed(true);
  };

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 bg-primary-600 text-white flex items-center justify-center px-10"
      style={{ height: BAR_HEIGHT }}
    >
      <a
        href={BAR_LINK}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onTap}
        className="flex flex-col items-center text-center leading-tight"
      >
        <span className="text-xs sm:text-sm font-bold">{BAR_TITLE}</span>
        <span className="text-[11px] sm:text-xs underline underline-offset-2 opacity-95">{BAR_SUB}</span>
      </a>
      <button onClick={onClose} aria-label="Close" className="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 cursor-pointer opacity-80 hover:opacity-100">
        ✕
      </button>
    </div>
  );
}
